<div class="admin-jobs">
  <h2>Jobs</h2>
  <div class="row pb-2">
    <div class="col-2">
      <button type="button" class="btn btn-primary" (click)="getJobLog()">Get job log</button>
    </div>
    <div class="col">
      <input type="text" class="form-control" [(ngModel)]="jobLogId" placeholder="Enter job id">
    </div>
  </div>
  <div class="row pb-3">
    <div class="col">
      <textarea class="form-control" rows="5" [(ngModel)]="jobLog"></textarea>
    </div>
  </div>
  <div class="row">
    <div class="col-2">
      <button type="button" class="btn btn-primary" (click)="cancelJob()">Cancel Job</button>
    </div>
    <div class="col">
      <input type="text" class="form-control" [(ngModel)]="jobCancelId" placeholder="Enter job id">
    </div>
  </div>
</div>
